import { Box } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { useActivityString } from "@outschool/ui-components-website";
import { Checkbox } from "@outschool/ui-legacy-component-library";
import { without } from "lodash";
import React from "react";

import { usGradeLevels } from "../../../../../shared/Activity";
import { Filter } from "../Filter";
import { ListingChildFilterProps } from "./ListingFilters";

type LevelFilterProps = {
  values: string[];
  title: string;
  options: string[];
  onChange: (newValue?: string | null) => void;
};

export function GradeLevelFilter({
  searchFilters,
  onChange
}: ListingChildFilterProps) {
  const { t } = useTranslation(
    "client\\components\\search\\mobile\\filters\\LevelFilter"
  );

  const levelValue = searchFilters.gradeLevel
    ? searchFilters.gradeLevel.split(",")
    : [];
  return (
    <LevelFilter
      values={levelValue}
      title={t("US grade level")}
      options={usGradeLevels}
      onChange={newValue => {
        onChange && onChange({ gradeLevel: newValue });
      }}
    />
  );
}

function LevelFilter({ values, options, onChange }: LevelFilterProps) {
  const { translateGradeLevel } = useActivityString();

  return (
    <Filter showTopBorder={false}>
      <Box
        sx={{
          padding: "12px 24px 24px 0px",
          fontSize: "1em"
        }}
      >
        {options.map(level => (
          <Checkbox
            key={level}
            id={level}
            label={translateGradeLevel(level)}
            checked={values.some(s => s === level)}
            iconSize="1em"
            onChange={e => {
              const checked = e.target.checked;
              const newValues = checked
                ? [...values, level]
                : without(values, level);

              onChange(newValues.join(","));
            }}
            sx={{
              cursor: "pointer",
              marginBottom: "small"
            }}
          />
        ))}
      </Box>
    </Filter>
  );
}
